// our route config
import PDP from "./Detail";
import PLP from "./Listing";
import PrivatePolicy from "./PrivatePolicy";
import HOME from "./Homepage";
import Search from "./Search";
import MobileAuthFlow from "./MobileAuthFlow";
import OfferPage from "./Offerpage";
import LandingPage from "./LandingPage";
import Generic from "./Generic";
import AboutUs from "./AboutUs";

export const routesWithAppLayout = [
    {
        path: "/",
        component: HOME,
        exact: true,
    },
    {
        path: "/international",
        component: HOME,
    },
    {
        path: "/detail/:sku",
        component: PDP,
    },
    {
        path: "/:slug/p/:id",
        component: PDP,
    },
    {
        path: "/privacy-policy.html",
        component: PrivatePolicy,
    },
    {
        path: "/catalogsearch/result",
        component: Search,
    },
    {
        path: "/:category/c/:id",
        component: PLP,
    },
    {
        path: "/:category/:subCategory/c/:id",
        component: PLP,
    },
    {
        path: "/:category/:subCategory/:subSubCategory/c/:id",
        component: PLP,
    },
    {
        path: "/offer.html",
        component: OfferPage,
    },
    {
        path: "/lp/*",
        component: LandingPage,
    },
    {
        path: "/personal-boutique",
        component: Generic,
    },
    {
        path: "/about-us.html",
        component: AboutUs,
    },
];

export const routesWithoutAppLayout = [
    {
        path: "/authorization",
        component: MobileAuthFlow,
    },
];
